// RequiredField.jsx
import React from 'react';
import { Form } from 'react-bootstrap';

/**
 * RequiredField component for rendering text input fields
 *
 * @param {Object} props
 * @param {string|React.Component} props.label - Label for the field
 * @param {string} props.name - Name attribute for the field
 * @param {string} props.value - Current value
 * @param {Function} props.onChange - Change handler function
 * @param {string} props.placeholder - Placeholder text
 * @param {string} props.error - Error message to display
 * @param {string} props.type - Input type (default: 'text')
 * @param {Object} props.style - Additional styling for the field
 */
const RequiredField = ({
                           label,
                           name,
                           value,
                           onChange,
                           placeholder,
                           error,
                           type = 'text',
                           style,
                           className,
                           ...props
                       }) => {
    return (
        <Form.Group>
            <Form.Label>
                {label}
            </Form.Label>
            <Form.Control
                type={type}
                name={name}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                isInvalid={!!error}
                style={style}
                className={className}
                {...props}
            />
            {error && (
                <Form.Control.Feedback type="invalid">
                    {error}
                </Form.Control.Feedback>
            )}
        </Form.Group>
    );
};

export default RequiredField;